<template>
  <base-row
    :class="{ 'flex-col': collapsable }"
    :expanded="shouldShowCollapsableContent"
  >
    <a
      :class="[
        $style.MenuItem,
        {
          [$style['MenuItem--inactive']]: !active
        }
      ]"
      @click.prevent="handleClick"
    >
      <div class="flex flex-grow">
        <div class="flex-grow">
          <slot />
        </div>
        <div class="self-center">
          <base-icon
            name="arrow-right-icon"
            size="xs"
            class="inline-block"
            :class="{ 'mr-1': !isCollapsed }"
            style="transition: 0.14s"
            :style="iconRotationStyle"
          />
        </div>
      </div>
    </a>
    <div v-show="shouldShowCollapsableContent">
      <slot name="collapsable" />
    </div>
  </base-row>
</template>
<script>
import Redirect from '@/mixins/redirect';

export default {
  name: 'MenuItem',
  mixins: [Redirect],
  props: {
    to: {
      type: String,
      required: false,
      default: () => null
    },
    active: {
      type: Boolean,
      required: false,
      default: true
    },
    collapsable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: true
    };
  },
  computed: {
    iconRotationStyle() {
      return {
        transform: `rotate(${this.isCollapsed ? 0 : 90}deg)`
      };
    },
    shouldShowCollapsableContent() {
      return this.collapsable && !this.isCollapsed;
    }
  },
  methods: {
    handleClick() {
      if (null !== this.to) {
        this.redirect(this.to, 'always', 'instant');
        return;
      }
      this.$emit('collapsed', this.isCollapsed);
      this.isCollapsed = !this.isCollapsed;
    }
  }
};
</script>
<style lang="scss" src="../scss/components/MenuItem.scss" module></style>
